// Types
import type { TTableHeaders } from '~/misc/v-table/types';

const TABLE_HEADERS: TTableHeaders = ['Name', 'Source', 'Date', 'Description'];

export { TABLE_HEADERS };
